import { useQuery } from '@apollo/client';
import { Container } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import gql from 'graphql-tag';
import { useCallback } from 'react';
import useAnalytics from '../../../lib/hooks/useAnalytics';
import { ANALYTICS_EVENTS, COUNTRY_CODES } from '../../constants';
import { GASBACK } from '../../constants/metrics';
import AppPromo from '../AppPromo';
import { FeaturedGasBackBrands } from '../FeaturedGasbackBrands';
import GasBackBrands from '../GasbackBrands';
import GasBackHero from '../GasbackHero';
import GasBackGuide from '../GasbackLandingGuide';
import GasBackPayPromo from '../GasbackPayPromo';
import MetricsBox from '../MetricsBox';
import Page from '../Page';
import styles from './GasBackLanding.module.css';

const cx = classnames.bind(styles);

const PAGE_NAME = 'GasBack_Landing';
const PAGE_TITLE = 'Get Free Money for Gas - Shops Brands You Know | GasBuddy GasBack';
const PAGE_DESCRIPTION = 'Get a free gas rewards card from GasBuddy. You can earn 10% back on purchases at stores you know. Save on gas with everyday purchases with GasBack.';

export const GET_OFFERS = gql`
  query GasBackLanding {
    offers {
      partner {
        imageUrl
        name
      }
      tags
    }
  }
`;

export default function GasBackLanding() {
  const analytics = useAnalytics();
  const { data } = useQuery(GET_OFFERS);
  const offers = data?.offers.map(offer => ({
    title: offer.partner?.name,
    logo: offer.partner?.imageUrl ? `//images.gasbuddy.io/autox100/${offer.partner.imageUrl}` : undefined,
    tags: offer.tags,
  })) || [];
  // filter out offers that don't have a logo so that we don't just show an empty bubble
  const featuredOffers = offers?.filter(({ logo, tags }) => tags && tags.includes('featured_web') && !!logo);

  const handleGetAppClicked = useCallback(section => () => {
    analytics.tagEvent({
      name: ANALYTICS_EVENTS.APP_STORE_LINK_CLICK,
      attributes: {
        Store: 'Unknown',
        'Screen Name': PAGE_NAME,
        Section: section,
      },
    });
  }, [analytics]);

  const handleGoToPayClicked = useCallback(() => {
    analytics.tagEvent({
      name: ANALYTICS_EVENTS.PAY_CTA_CLICKED,
      attributes: {
        'Screen Name': PAGE_NAME,
        Section: 'PayPromo',
      },
    });
  }, [analytics]);

  return (
    <Page
      compact
      description={PAGE_DESCRIPTION}
      name={PAGE_NAME}
      title={PAGE_TITLE}
    >
      <div className={cx('content')}>
        <GasBackHero onButtonClick={handleGetAppClicked('Hero')} />
        <Container className={cx('featuredBrands')}>
          <FeaturedGasBackBrands
            brands={featuredOffers}
          />
        </Container>
        <div className={cx('guide')}>
          <GasBackGuide onButtonClick={handleGetAppClicked('Guide')} />
        </div>
        <Container className={cx('container')}>
          <MetricsBox
            header="Join the thousands earning GasBack every day."
            metrics={GASBACK}
          />
        </Container>
        <Container className={cx('container')}>
          <GasBackPayPromo onButtonClick={handleGoToPayClicked} />
        </Container>
        <GasBackBrands brands={offers} />
        <br />
        <br />
        <AppPromo country={COUNTRY_CODES.USA} screenName="GasBack Landing" />
        <br />
        <br />
      </div>
    </Page>
  );
}
